import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { cx, ui } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import * as styles from './Switch.styles';

function SwitchToggle(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      props = _objectWithoutProperties(_ref, ["className", "size"]);

  var classes = cx(styles.Toggle, size === 'large' && styles.toggleLarge, size === 'small' && styles.toggleSmall, className);
  return /*#__PURE__*/React.createElement(View, Object.assign({
    "aria-hidden": true
  }, ui.$('SwitchToggle'), props, {
    className: classes
  }));
}

export default /*#__PURE__*/React.memo(SwitchToggle);